import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { KeyboardArrowDown, LogoutOutlined, Notifications } from '@mui/icons-material';
import { MenuList, Box, Typography, IconButton, Menu, Divider, useTheme } from '@mui/material';

import { language, help } from '@frontend/assets';
import { useAuth } from '@frontend/features/auth/hooks/useAuth';

import { MyMenuItem, MyMenuIcon } from './styles';
import { LoadingButton } from '@mui/lab';

interface ConfigsProps {
  onOpenNotifications: () => void;
}

export const Configs: FC<ConfigsProps> = ({ onOpenNotifications }) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const { checkIsLogged, isAuthenticated, doSignOut } = useAuth();
  const [, setLoading] = useState(false);
  const [lngAnchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleSetLanguage = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);

  const handleCloseMenu = () => setAnchorEl(null);

  useEffect(() => {
    checkIsLogged();
    setLoading(false);
  }, [checkIsLogged, setLoading]);

  return (
    <>
      {isAuthenticated && (
        <>
          <Divider sx={{ my: theme.spacing(2) }} />
          <MenuList>
            {/*
       
         Esto era una mentira.. :/
         Lo implementamos después, ahora no perdamos el tiempos
         Dejo comentado para después retomar
 
         <MyMenuItem>
           <MyMenuIcon src={currency} />
           <Box display="flex" alignItems={'flex-start'} justifyContent={'space-between'} flex={'1 0 0'}>
             <Typography color={'primary'} variant="subtitle1">
               {t('common.nav.userMenu.currentCurrency')}
             </Typography>
             <Box display={'flex'}>
               <Typography color="text.disabled" variant="subtitle1">
                 {t('common.currencies.usd')}
               </Typography>
               <IconButton onClick={handleSetLanguage} sx={{ padding: 0 }}>
                 <KeyboardArrowDown color="primary" />
               </IconButton>
             </Box>
           </Box>
         </MyMenuItem>
         
         */}

            <MyMenuItem>
              <MyMenuIcon src={language} />
              <Box display="flex" alignItems={'flex-start'} justifyContent={'space-between'} flex={'1 0 0'}>
                <Typography color={'primary'} variant="subtitle1">
                  {t('common.nav.userMenu.currentLanguage')}
                </Typography>
                <Box display={'flex'}>
                  <Typography color="text.disabled" variant="subtitle1">
                    {t('common.nav.userMenu.selectedLanguage')}
                  </Typography>
                  <IconButton onClick={handleSetLanguage} sx={{ padding: 0 }}>
                    <KeyboardArrowDown color="primary" />
                  </IconButton>
                </Box>
                <Menu anchorEl={lngAnchorEl} open={Boolean(lngAnchorEl)} onClose={handleCloseMenu}>
                  <MenuList>
                    <MyMenuItem onClick={() => i18n.changeLanguage('es')}>
                      <Typography color="text.disabled" variant="subtitle1">
                        {t('common.language.spanish')}
                      </Typography>
                    </MyMenuItem>
                    <MyMenuItem onClick={() => i18n.changeLanguage('en')}>
                      <Typography color="text.disabled" variant="subtitle1">
                        {t('common.language.english')}
                      </Typography>
                    </MyMenuItem>
                  </MenuList>
                </Menu>
              </Box>
            </MyMenuItem>

            <MyMenuItem onClick={onOpenNotifications}>
              <Notifications sx={{ width: 24, height: 24, mr: 2 }} color="primary" />
              <Typography variant="subtitle1" color={'primary'}>
                {t('userNotificationTriggers.title')}
              </Typography>
            </MyMenuItem>

            <MyMenuItem>
              <MyMenuIcon src={help} />
              <Typography variant="subtitle1" color={'primary'}>
                {t('common.nav.userMenu.help')}
              </Typography>
            </MyMenuItem>
          </MenuList>
          <LoadingButton
            fullWidth
            size="medium"
            color="primary"
            variant="outlined"
            type="submit"
            onClick={doSignOut}
            sx={{ marginTop: theme.spacing(6.5), borderRadius: theme.spacing(1) }}
          >
            <Typography
              sx={{
                letterSpacing: '0.4px',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
              }}
              variant="subtitle2"
            >
              <LogoutOutlined sx={{ mr: theme.spacing(1) }} />
              {t('auth.login.logoutMesssage')}
            </Typography>
          </LoadingButton>
        </>
      )}
    </>
  );
};
